module.exports = __webpack_public_path__ + "static/media/channel-assistant.d0011470.svg";